/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { ClassroomItemType } from './ClassroomItemType';
import {
    ClassroomItemTypeFromJSON,
    ClassroomItemTypeFromJSONTyped,
    ClassroomItemTypeToJSON,
} from './ClassroomItemType';

/**
 * 
 * @export
 * @interface AttachTaskRequestContent
 */
export interface AttachTaskRequestContent {
    /**
     * 
     * @type {ClassroomItemType}
     * @memberof AttachTaskRequestContent
     */
    itemType: ClassroomItemType;
    /**
     * The opaque token Google Classroom passes to the iframe which must
be echoed back when interacting with add-on APIs.
     * @type {string}
     * @memberof AttachTaskRequestContent
     */
    addOnToken: string;
    /**
     * The experience that owns the catalog entry selected in the iframe UI.
     * @type {string}
     * @memberof AttachTaskRequestContent
     */
    experienceId: string;
    /**
     * The catalog entry selected in the iframe UI.
     * @type {string}
     * @memberof AttachTaskRequestContent
     */
    entryId: string;
}


/**
 * Check if a given object implements the AttachTaskRequestContent interface.
 */
export function instanceOfAttachTaskRequestContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "itemType" in value;
    isInstance = isInstance && "addOnToken" in value;
    isInstance = isInstance && "experienceId" in value;
    isInstance = isInstance && "entryId" in value;
    return isInstance;
}

export function AttachTaskRequestContentFromJSON(json: any): AttachTaskRequestContent {
    return AttachTaskRequestContentFromJSONTyped(json, false);
}

export function AttachTaskRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttachTaskRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'itemType': ClassroomItemTypeFromJSON(json['itemType']),
        'addOnToken': json['addOnToken'],
        'experienceId': json['experienceId'],
        'entryId': json['entryId'],
    };
}

export function AttachTaskRequestContentToJSON(value?: AttachTaskRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'itemType': ClassroomItemTypeToJSON(value.itemType),
        'addOnToken': value.addOnToken,
        'experienceId': value.experienceId,
        'entryId': value.entryId,
    };
}

